module.exports = "<div class=\"nocontent\" [ngClass]=\"themeVar\">\n    <h2>No product loaded yet!</h2>\n</div>\n"